import { useCallback } from 'react';
import { type FileDownload, type SelectedFile } from 'components/DynamicDownload/interfaces';
import { useAppDispatch } from 'features';
import { addDownloadFile, updateDownloadFileStatus } from 'features/Downloads';
import { getFileBlobFromURL } from 'util/getFileBlobFromURL';
import { saveBlobAsLocalFile } from 'util/saveBlobAsLocalFile';

export const useFileDownloader = () => {
  const dispatch = useAppDispatch();

  const downloadFile = useCallback(
    async (file: FileDownload) => {
      const newFile: SelectedFile = { ...file, status: 'downloading' };

      dispatch(addDownloadFile(newFile));

      try {
        const data = await getFileBlobFromURL(file.url);
        if (data) {
          saveBlobAsLocalFile(data, file.name, file.type);
          dispatch(updateDownloadFileStatus(file.id, 'downloaded'));
        }
      } catch (error) {
        dispatch(updateDownloadFileStatus(file.id, 'error'));
      }
    },
    [dispatch]
  );

  return { downloadFile };
};
